import React from 'react';
import PremiosUsuario from '../../components/PremiosUsuario';

const PremiosUsuarioPage = () => (
	<PremiosUsuario />
);

export default PremiosUsuarioPage;
